export default {"src":"/_next/static/media/OPT-Green-Butterfly-only.1c1cc4f6.svg","height":201,"width":201,"blurWidth":0,"blurHeight":0};